module.exports = __webpack_public_path__ + "img/herring.e0cc66a8.png";